import { z } from 'zod';
/**
 * The canonical minigame ID union. Adding a minigame starts here.
 *
 * This is intentionally the *only* place the set of games is enumerated as a
 * type. The server registry and the client registry are both keyed by it, so
 * forgetting to register a new game is a compile error rather than a runtime
 * "unknown minigame" at 2am.
 */
export const MINIGAME_IDS = [
    'tile-tap',
    'wordle',
    'nerdle',
    'word-ladder',
    'chess-mate',
    'flow',
    'twenty-four',
    'rush-hour',
    'flood-it',
    'two048',
    // Flappy: a solo seeded side-scroller; sudden-death vs the opponent's parallel run.
    'flappy',
    // Turn games: shared-board, alternating-move duels that plug in as ordinary
    // race segments via the turn adapter (winner "solves", loser is penalised).
    'connect-four',
    'tic-tac-toe',
    'battleship',
    // Reaction Duel: a simultaneous real-time reflex game, also on the turn adapter.
    'reaction-duel',
    // Find Match: a simultaneous Dobble/Spot-It duel, also on the turn adapter.
    'find-match',
    // Soccer: a turn-based flick-physics duel (Soccer Stars), on the turn adapter.
    'soccer',
];
export const MinigameId = z.enum(MINIGAME_IDS);
/**
 * A match recipe is an ordered list of minigame IDs. Order is play order.
 *
 * The schema does not forbid repeats, because an explicitly-supplied recipe may
 * legitimately want one (a fixed lineup, a test). The *drawn* recipe never
 * repeats — see `buildRecipe` in the server registry, where that rule lives.
 */
export const Recipe = z.array(MinigameId).min(1).max(16);
export const asMatchId = (s) => s;
export const asUserId = (s) => s;
export const asRoomCode = (s) => s;
/**
 * Room codes are the one ID a human types. Restricted to an unambiguous
 * alphabet (no O/0, no I/1/L) and matched case-insensitively at the boundary.
 */
export const ROOM_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
export const ROOM_CODE_LENGTH = 6;
export const RoomCodeSchema = z
    .string()
    .trim()
    .toUpperCase()
    .regex(new RegExp(`^[${ROOM_CODE_ALPHABET}]{${ROOM_CODE_LENGTH}}$`), 'Invalid room code');
//# sourceMappingURL=ids.js.map